import React from "react";
//#region types
import { DisplayProps, WintVerticalFormFieldProps } from "models/propTypes/wintFormPropsTypes";
//#endregion
//#region components
import ReadOnlyFormField from "./readOnlyFormField";
import cssExports from "theme/styles/main.module.scss";
//#endregion

export type ReadOnlyVerticalFormFieldProps<T extends DisplayProps> = WintVerticalFormFieldProps & T;

function ReadOnlyVerticalFormField<T extends DisplayProps>(props: ReadOnlyVerticalFormFieldProps<T>) {
  const { showMainLabel } = props;

  return (
    <ReadOnlyFormField<T>
      {...props}
      direction="vertical"
      hideMainLabel={!showMainLabel}
      className={cssExports.groupSectionChildInline}
    />
  );
}

export default ReadOnlyVerticalFormField;
